export default __webpack_public_path__ + "static/media/spinner.690d28e6.gif";